import { DateUtils, DateFormatOptions } from '@wyz/utils';
import React from 'react';

interface Props {
  date?: Date;
  format?: DateFormatOptions['format'];
  timezone?: DateFormatOptions['timezone'];
  fallback?: string;
  locale?: DateFormatOptions['locale'];
}

const FormatDate: React.FC<Props> = ({
  date,
  format,
  timezone,
  fallback = '-',
  locale,
}: Props) => {
  return (
    <>
      {date
        ? DateUtils.formatTimestamp(new Date(date), {
            locale,
            format,
            timezone,
          })
        : fallback}
    </>
  );
};

export default FormatDate;
